var map = {
	"./mts-main-products-boards.mp4": 3176,
	"./mts-main-products-chats.mp4": 3177,
	"./mts-main-products-comdi.mp4": 3178,
	"./mts-main-products-courses.mp4": 3179,
	"./mts-main-products-equipment.mp4": 3180,
	"./mts-main-products-forms.mp4": 3181,
	"./mts-main-products-meetings.mp4": 3182,
	"./mts-main-products-webinars.mp4": 3183,
	"./mts-products-chats-account-management.mp4": 3184,
	"./mts-products-chats-adding-employees.mp4": 3185,
	"./mts-products-chats-ai-assistant.mp4": 3186,
	"./mts-products-chats-appointment-moderators.mp4": 3187,
	"./mts-products-chats-chats-and-channels.mp4": 3188,
	"./mts-products-chats-distribution-groups.mp4": 3189,
	"./mts-products-chats-favorite-features.mp4": 3190,
	"./mts-products-chats-in-platform.mp4": 2342,
	"./mts-products-chats-one-click-call.mp4": 3191,
	"./mts-products-chats-promo-mobile.mp4": 2339,
	"./mts-products-chats-promo.mp4": 2447,
	"./mts-products-comdi.mp4": 2334,
	"./tab-intelligence-video.mp4": 2343,
	"./webinar-meetings.mp4": 3192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2341;